export const AccessLevel = Object.freeze({
  NONE:    'none',
  READER:  'reader',
  EDITOR:  'editor',
})

export const AccessLevelDescriptions = Object.freeze({
  [AccessLevel.NONE]:   'Sem acesso',
  [AccessLevel.READER]: 'Somente leitura',
  [AccessLevel.EDITOR]: 'Gerenciar ações',
})
